import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { searchHistoryBackend } from './search-history.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { searchHistoryReducer } from './search-history.reducer';

// FIXME: remove that
backend.searchHistory = searchHistoryBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('searchHistory', searchHistoryReducer),
    /* DatastoreBackendModule.forFeature(
      'searchHistory',
      searchHistoryBackend,
    ),*/
  ],
})
export class DatastoreSearchHistoryModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-history/search-history.module.ts